<template
  ><div>
    <two-blocks-layout :navigate="navigate" v-bind="page">
      <span class="text-outline text-title-md" v-text="`${page.titolo1} `" />
      <span class="text-title-md " v-text="page.titolo2" />
    </two-blocks-layout>
    <router-view v-slot="{ Component }">
      <transition name="pop">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>
<script>
import { axios } from "@/plugins/axios";
import TwoBlocksLayout from "@/components/page-layouts/TwoBlocksLayout.vue";
import { matchedRouteKey } from "vue-router";

export default {
  inject: [matchedRouteKey],
  components: { TwoBlocksLayout },
  props: { navigate: { default: null } },
  computed: {
    navRoute() {
      return this[matchedRouteKey].value;
    }
  },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  },
  async beforeRouteUpdate() {
    let page;
    try {
      page = await axios.get(`/pageContent${this.navRoute.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      this.page = page.data;
    }
  }
};
</script>
<route>
{
  "name": "Bancomat Pay",
  "meta": {
      "tabOrder": 4
  }
}
</route>
